module.exports = __webpack_public_path__ + "img/toolbar_bg1.a555bbff.jpg";